import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event';

@Directive({
  selector: '[isEllipsisActive]'
})
export class IsEllipsisActiveDirective implements AfterViewInit {
  @Input() onResize: EventEmitter<any>;
  loading: boolean;
  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.onResize.subscribe(o => {
      if (this.loading)
        return;
      this.loading = true;
      this.setData();
      this.loading = false;
    })
    setTimeout(() => {
      this.setData();
      this.loading = false;
      setTimeout(() => {
        this.setData();
      }, 500)
    }, 500)
  }

  private setData() {
    const element = this.elementRef.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      element.classList.add('ellipse-active')
    }
    else {
      if (element.classList.contains('ellipse-active'))
        element.classList.remove('ellipse-active')
    }
  }

  onResized(event: ResizedEvent) {
    //console.log('resize')
  }
}
